import { AlertTriangleIcon } from '@langchain/untitled-ui-icons';
import { Button, Modal, ModalClose, ModalDialog } from '@mui/joy';

import { FC } from 'react';
import { Link } from 'react-router-dom';

import { addQueryParams } from '@/utils/add-query-params';

type TProps = {
  setShowProxyProviderWarningModal: (open: boolean) => void;
  playgroundLinkBase: string;
  playgroundParams:
    | {
        organizationId: string;
        commit: string | undefined;
      }
    | {
        commit: string | undefined;
        organizationId?: undefined;
      };
};

const ProxyProviderWarningModal: FC<TProps> = ({
  setShowProxyProviderWarningModal,
  playgroundLinkBase,
  playgroundParams,
}) => {
  return (
    <Modal open={true} onClose={() => setShowProxyProviderWarningModal(false)}>
      <ModalDialog style={{ width: '400px' }}>
        <ModalClose />
        <div className="flex flex-col gap-2 text-warning">
          <AlertTriangleIcon className="h-12 w-12 rounded-full bg-warning-secondary p-[10px]" />
          <span className="text-lg font-semibold text-primary">
            Proxy Provider Data Risk Warning
          </span>
          <span className="text-sm text-tertiary">
            This action involves using a proxy provider, which could expose
            sensitive data, including your API keys, to the provider's owner.
            Are you certain you want to proceed?
          </span>
          <div className="flex w-full items-center justify-end gap-2 pt-8">
            <Button
              variant="outlined"
              color="neutral"
              className="flex-grow"
              onClick={() => setShowProxyProviderWarningModal(false)}
            >
              Cancel
            </Button>
            <Link
              to={addQueryParams(playgroundLinkBase, playgroundParams)}
              className="flex-grow"
            >
              <Button color="primary" className="w-full">
                Continue
              </Button>
            </Link>
          </div>
        </div>
      </ModalDialog>
    </Modal>
  );
};

export default ProxyProviderWarningModal;
